export default [
	{  //采购单列表
		path: 'order',
		name: 'm_purchase_order',
		meta: {
			templateManage: {
				workType: 39,
				print: 'b_purchase_order_printtemplate',
				export: 'b_purchase_order_exporttemplate'
			},
			appView: {
				viewId: '90037',
				detailView: [{
					name: '详情-产品明细',
					viewId: '90038'
				}],
				auth: 'b_purchase_order_viewmanage'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/purchase/purchase_order_list.vue')
	},
	{  //采购单明细列表
		path: 'product',
		name: 'm_purchase_product',
		meta: {
			templateManage: {
				workType: 40,
				print: 'b_purchase_product_printtemplate',
				export: 'b_purchase_product_exporttemplate'
			}
		},
		component: () => import('@/pages/purchase/purchase_product_list.vue')
	}
];